import { View, VStack } from "@gluestack-ui/themed";
import { InvoicePaymentController } from "./controller";
import { Text } from "@repo/core/components/core/Text";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { Button } from "@repo/core/components/core/Button";
import { IdentityTypeInput } from "@repo/core/components/forms/IdentityTypeInput";
import { ValueInfoSection } from "./components/ValueInfoSection";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const InvoicePayment = () => {
  const {
    title,
    back,
    isMobile,
    control,
    onChangeIdentityType,
    selectedIdentityInputType,
    handleOnSelectProduct,
    onFetchCard,
    onFetchProducts,
    onFetchCardFinish,
    onFetchProductsFinish,
    isSubmitting,
    handleOnSubmitForm,
    isLoading,
    invoiceInfo,
    paymentType,
    dealInfo,
    onChangeCard,
    onChangeCPF
  } = InvoicePaymentController();
  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect title={title}>
        <Scaffolds.Form
          showHeader={false}
          footerContent={
            <View
              w="$full"
              gap="$4"
              flexDirection={!isMobile ? "row-reverse" : "column"}
              pt={isMobile ? "$4" : "$12"}
              px="$4"
              pb="$4"
              justifyContent="flex-end"
            >
              <Button
                flex={isMobile ? undefined : 1}
                size="xl"
                isLoading={isSubmitting}
                action={"primary"}
                text="Concluir transação"
                onPress={handleOnSubmitForm}
              />
              <Button
                flex={isMobile ? undefined : 1}
                isDisabled={isSubmitting}
                variant="outline"
                action="negative"
                size="xl"
                text="Cancelar"
                onPress={back}
              />
            </View>
          }
        >
          <VStack gap={24} px="$4" flex={1}>
            <Text>Insira os dados do pagamento:</Text>

            <IdentityTypeInput
              onChangeInputType={onChangeIdentityType}
              control={control}
              selectedInputType={selectedIdentityInputType}
              onSelectProduct={handleOnSelectProduct}
              onFetchProducts={onFetchProducts}
              onFetchCard={onFetchCard}
              onFetchCardFinish={onFetchCardFinish}
              onFetchProductsFinish={onFetchProductsFinish}
              onChangeCard={onChangeCard}
              onChangeCPF={onChangeCPF}
              showProductsLoading={false}
              showCardExpiryInput={false}
            />

            <ValueInfoSection
              isLoading={isLoading}
              paymentType={paymentType}
              invoiceInfo={invoiceInfo}
              dealInfo={dealInfo}
            />

            <InputControlled
              control={control}
              name="paymentValue"
              size="md"
              returnKeyType="next"
              label="Valor do Pagamento"
              isCurrency
              isBigInput
              isRequired
              keyboardType="number-pad"
            />
          </VStack>
        </Scaffolds.Form>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};

export default InvoicePayment;
